<script setup lang="ts">
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";

defineProps<{ size: "small" | "medium" }>();
</script>

<template>
  <BaseButton
    class="choose-button"
    variant="outlined"
    color="grey"
    :size
    full-width
    icon-after="arrow/chevron-right"
  >
    <slot />
  </BaseButton>
</template>

<style lang="scss">
@use "@/styles/font";
@use "@/styles/variables/colors";

.choose-button {
  &.base-button.outlined.grey {
    justify-content: space-between;
    padding: 20px;
    border-radius: 8px;
    color: colors.$text;

    > div,
    > span {
      flex-grow: 1;
    }

    &.small {
      font-size: 14px;
    }

    &.medium {
      font-size: 18px;
      font-weight: font.$weight-bold;
      height: 80px;
      flex-shrink: 0;

      > * {
        height: auto;
      }
    }
  }
}
</style>
